import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a2a968c7-5c04-ed93-f0b2-82e6fe4c2a57",
  "use": "icon-a2a968c7-5c04-ed93-f0b2-82e6fe4c2a57-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-a2a968c7-5c04-ed93-f0b2-82e6fe4c2a57\"><defs><style type=\"text/css\"></style></defs><path d=\"M174.297872 7.262411L0 1009.475177l65.361702 14.524823L246.921986 21.787234l-72.624114-14.524823zM864.22695 0l-65.361702 14.524823L951.375887 1016.737589l65.361702-14.524823L864.22695 0z\" fill=\"#5E6E7D\" p-id=\"5717\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol